<template>
  <div>
    <v-data-table :headers="headers" :items="listAlerts" class="elevation-1">
      <template v-slot:item.action="{ item }">
        <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'ListAlerts',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Name',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.$store.dispatch('alerts/getAlerts');
  },
  computed: {
    listAlerts() {
      return this.$store.state.alerts.alerts;
    },
  },
  methods: {
    editItem(item) {
      const { id } = item;
      this.$router.push({ name: 'Editare Alerta', params: { id } });
    },
    deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('alerts/delete', item.id);
      }
    },
  },
};
</script>
